var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUntagOutline = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2 -2 18 18",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 2.25c-.623 0-1.125.502-1.125 1.125S2.752 4.5 3.375 4.5 4.5 3.998 4.5 3.375 3.998 2.25 3.375 2.25zm0 0c-.623 0-1.125.502-1.125 1.125S2.752 4.5 3.375 4.5 4.5 3.998 4.5 3.375 3.998 2.25 3.375 2.25zm11.182 4.935L7.807.435A1.498 1.498 0 006.75 0H1.5C.675 0 0 .675 0 1.5v5.25c0 .397.158.78.443 1.065l.307.3a4.322 4.322 0 011.56-.555l-.81-.81V1.5h5.25l6.75 6.75-5.25 5.25-.81-.81a4.14 4.14 0 01-.555 1.56l.308.307c.277.285.66.443 1.057.443.398 0 .78-.158 1.057-.443l5.25-5.25c.285-.277.443-.66.443-1.057 0-.397-.158-.78-.443-1.065zM3.375 2.25c-.623 0-1.125.502-1.125 1.125S2.752 4.5 3.375 4.5 4.5 3.998 4.5 3.375 3.998 2.25 3.375 2.25zM6 12.75H0v-1.5h6v1.5z"
  })));
};
export default SvgUntagOutline;